import Api from './Api';

const GetAnonymousContact = (currentPage, searchText, aproved) => {
  return Api().get('/anonymous-contact', {
    params: {
      page: currentPage,
      message: searchText,
      aproved: aproved,
    },
  });
};

const PostAnonymous = (dados) => {
  return Api().post('/anonymous-contact', dados);
};

const deleteAnonymousContact = (id) => {
  return Api().delete(`/anonymous-contact/delete/${id}`);
};

const GetAnonymousPostsId = (id) => {
  return Api().get(`/anonymous-contact/${id}`);
};

const PatchAnonymous = (id, aproved) => {
  return Api().patch(`/anonymous-contact/aprove/${id}`, aproved);
};

const GetAnonymousAproved = (perPage, currentPage) => {
  return Api().get('/anonymous-contact/approved/all', {
    params: {
      perPage: perPage,
      page: currentPage,
    },
  });
};

const GetAnonymousPostagensId = (id) => {
  return Api().get(`/anonymous-contact/approved/id/${id}`);
};

const PatchReactions = (id, reactions) => {
  return Api().patch(`/anonymous-contact/reactions/${id}`, reactions);
};

export {
  GetAnonymousContact,
  PostAnonymous,
  deleteAnonymousContact,
  PatchAnonymous,
  GetAnonymousPostsId,
  GetAnonymousAproved,
  GetAnonymousPostagensId,
  PatchReactions,
};
